module.exports = __webpack_public_path__ + "img/mapstatus.747d06a8.svg";